import FundamenteiWithText from "components/branding/FundamenteiWithText";
import LogoSizingProps from "components/branding/LogoSizingProps";
import LanguageSelector from "components/navbar/LanguageSelector";
import classNames from "components/ui/classNames";
import { useAmplitude } from "lib/amplitude/Amplitude";
import { preserveOnlyUtmParameters } from "lib/analytics/utm";
import { useFlagValue } from "lib/flagging/FeatureFlags";
import { LinkAnchorButton } from "lib/miolo";
import Link from "next/link";
import { useRouter } from "next/router";
import { FormattedMessage } from "react-intl";

export default function Header() {
  const router = useRouter();
  const amplitude = useAmplitude();
  const displayVideo = useFlagValue("marketing/landing/displayVideoOnLanding");

  return (
    <header className={classNames("flex max-w-7xl flex-col items-center justify-between lg:flex-row", "mx-auto py-16")}>
      <Link
        title="Fundamentei"
        href={{
          pathname: "/",
          query: preserveOnlyUtmParameters(router?.query),
        }}
      >
        <FundamenteiWithText className="inline-flex" {...LogoSizingProps.FundamenteiWithText.VERY_SMALL} />
      </Link>

      <nav className="my-6 flex w-full justify-center gap-x-6 scroll-smooth lg:my-0">
        <a
          className="text-base font-medium tracking-wide text-slate-600 hover:text-slate-950 hover:underline hover:underline-offset-4"
          href="#features"
        >
          <FormattedMessage defaultMessage="Funcionalidades" id="xOKb+g" />
        </a>
        <a
          href="/screener"
          className={classNames(
            "text-base font-medium tracking-wide text-slate-600 hover:text-slate-950",
            "hover:underline hover:underline-offset-4",
          )}
        >
          <FormattedMessage defaultMessage="Screener" id="STbb5d" />
          {false && (
            <sup className="absolute -right-3 -top-0.5 text-red-600 no-underline">
              <FormattedMessage defaultMessage="Novo" id="UPLEWq" />
            </sup>
          )}
        </a>
        <a
          className="text-base font-medium tracking-wide text-slate-600 hover:text-slate-950 hover:underline hover:underline-offset-4"
          href="#pricing"
        >
          <FormattedMessage defaultMessage="Preço" id="VFnrdw" />
        </a>
        <a
          className="text-base font-medium tracking-wide text-slate-600 hover:text-slate-950 hover:underline hover:underline-offset-4"
          href="#about"
        >
          <FormattedMessage defaultMessage="Sobre" id="/h9LIA" />
        </a>
        <a
          href="/blog"
          className={classNames(
            "text-base font-medium tracking-wide text-slate-600 hover:text-slate-950",
            "hover:underline hover:underline-offset-4",
          )}
        >
          Blog
        </a>
      </nav>

      <nav className="flex flex-row items-center gap-x-6 gap-y-4 text-center lg:text-left">
        <Link
          href={{
            pathname: "/login",
            query: preserveOnlyUtmParameters(router?.query),
          }}
          passHref={true}
          legacyBehavior={true}
        >
          <LinkAnchorButton className="text-base font-medium tracking-widest">Login</LinkAnchorButton>
        </Link>

        <Link
          href={{
            pathname: "/sign-up",
            query: preserveOnlyUtmParameters(router?.query),
          }}
          className={classNames(
            "m-0 box-border inline-block select-none overflow-visible whitespace-nowrap rounded-[20px] border border-brand",
            "appearance-none px-4 py-1 text-base font-medium text-brand no-underline",
            "transition-all duration-75 ease-in-out",
            "bg-brand text-white hover:opacity-90",
            "focus:shadow-[0_0_0_3px_#d1d9fa] focus:outline-none",
            "active:shadow-transparent",
          )}
          onClick={() => {
            amplitude.logEvent("Clicked on Sign Up on the landing page", {
              content: displayVideo ? "video" : "gif",
              location: "top",
            });
          }}
        >
          <FormattedMessage defaultMessage="Cadastre-se" description="Botão no cabeçalho da landing page" id="EoIVuI" />
        </Link>

        <LanguageSelector />
      </nav>
    </header>
  );
}
